import { useQueryClient } from "@tanstack/react-query"

import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { roadworksQueryKeys } from "../../queries/queryKeys"

import { useRoadworksMutation } from "./useRoadworksMutation"

export function useRoadworkCreate(
    queryParameters,
    config = {},
) {
    const url = "roadworks/"
    const { enabled = true } = config
    const queryClient = useQueryClient()

    return useRoadworksMutation(
        url,
        axiosInstance.post,
        {
            ...queryParameters,
        },
        {
            ...config,
            enabled: enabled,
            onSuccess: (newRoadwork) => {
                queryClient.setQueryData(roadworksQueryKeys["roadwork"](newRoadwork.uuid), newRoadwork)
                const roadworkGeoJSON = {
                    ...newRoadwork,
                    properties: { ...newRoadwork },
                }
                queryClient.setQueryData(roadworksQueryKeys["roadwork"](newRoadwork.uuid, { as_geojson: true }), roadworkGeoJSON)
                queryClient.invalidateQueries({ queryKey: roadworksQueryKeys.projectTaskType() })
                config?.onSuccess(newRoadwork)
            },
        },
    )
}